import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, IconButton, TextField, Typography } from '@mui/material'
import dashboard1 from '../../../assets/Project_Images/dashboard1.png'
import dashboard2 from '../../../assets/Project_Images/dashboard2.png'
import dashboard3 from '../../../assets/Project_Images/dashboard3.png'
import dashboard4 from '../../../assets/Project_Images/dashboard4.png'
import dashboard5 from '../../../assets/Project_Images/dashboard5.png'
import dashboard6 from '../../../assets/Project_Images/dashboard6.png'
import dashboard7 from '../../../assets/Project_Images/dashboard7.png'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Close, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import dayjs, { Dayjs } from 'dayjs'
import { ApiDashboardDetials, ApiGetAgreement, getVisitTimes } from '../../../apiService/Core/Apicall.tsx'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../Redux/Store.tsx'
import Loading from '../../Loader/Loading.tsx'
import { toast } from 'react-toastify'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { setSelectedMonth } from '../../../Redux/MonthSlice.tsx'
import { useNavigate } from 'react-router-dom'
import { setData } from '../../../Redux/GetTimeSlice.tsx'



function Dashboard() {
    const defaultMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch();
    const userdata = JSON.parse(localStorage.getItem('userData') || '{}');
    const [selectedmonth, setSelectedmonth] = useState<Dayjs>(dayjs(defaultMonth));
    const [Dashboarddata, setDashboarddata] = useState<any>([])
    const [openSignature, setopenSignature] = useState<boolean>(false)
    const loading = useSelector((state: RootState) => state.loader.isLoading);
    const [condition, setcondition] = useState<any>()
    const navigate = useNavigate()
    useEffect(() => {
        const getagreement = async () => {

            try {
                const res = await ApiGetAgreement()
                setcondition(res)
            } catch (error) {
                toast.error(error.message)
            }
        }
        getagreement()
        // if(userdata?.emailId != 'lisamelm@me.com' && userdata?.emailId != 'bryan_s_6@hotmail.com'){
        //     localStorage.setItem('i-n-d', "true")
        // }
    }, [])
    const fetchData = async () => {
        try {
            const response = await getVisitTimes();

            dispatch(setData(response.data));
        }
        catch (error: any) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    };

    useEffect(() => {
        fetchData();
    }, [dispatch]);
    const handlePrevMonth = () => {
        const newMonth = dayjs(defaultMonth).subtract(1, "month").toISOString();
        dispatch(setSelectedMonth(newMonth));
    };

    // Handle Next Month
    const handleNextMonth = () => {
        const newMonth = dayjs(defaultMonth).add(1, "month").toISOString();
        dispatch(setSelectedMonth(newMonth));
    };
    useEffect(() => {

        const ApiGetDetails = async () => {
            const data = `?userId=${userdata.userId}&month=${selectedmonth.month() + 1}&year=${selectedmonth.year()}`
            try {
                const result = await ApiDashboardDetials(data)
                setDashboarddata(result.response)
            } catch (error) {
                toast.error(error.message)
            }
        }
        ApiGetDetails()
    }, [selectedmonth])

    useEffect(() => {
        setSelectedmonth(dayjs(defaultMonth))
    }, [defaultMonth])

    // ---------------------------------------------- Signature -----------------------------------------------------

    return (
        <Box width='100%' position='relative' className='p-3' sx={{ overflowY: 'scroll' }} minHeight={{ xs: "calc(100vh + 120px)", lg: 'auto' }}>
            <Box className='d-flex flex-column  mb-1 align-items-center'>
                <Box className='d-flex w-100 mb-0 align-items-center gap-2'>
                    <Box component='img' borderRadius='10px' src={userdata.profilePicUrl} minWidth={'64px'} width={{ lg: '5%', xs: '7%' }}></Box>
                    <Typography fontWeight={900} variant='h5'> Welcome, <br />{userdata.firstName} {userdata.lastName}</Typography>
                </Box>
                <hr style={{ height: '1px', width: '100%', border: '1px solid #00000 !important' }} />
                <Box className='d-flex align-items-center justify-content-between w-100'>
                    <Typography fontWeight='bold' fontSize={{ xs: "16px", lg: '24px' }}>User Statistics</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box
                            display="flex"
                            alignItems="center"
                            maxWidth='250px'
                            width={{ lg: '50%', xs: '25%' }}
                            className="d-flex align-items-center justify-content-end"
                        >
                            {/* Previous Month Button */}
                            <IconButton
                                onClick={handlePrevMonth}
                                className="d-none d-md-block"
                            >
                                <KeyboardArrowLeft />
                            </IconButton>

                            {/* Month & Year Selector */}
                            <DatePicker
                                className=""
                                views={["year", "month"]}
                                value={selectedmonth}
                                onChange={(date) => { date && dispatch(setSelectedMonth(date.toISOString())) }}
                                slotProps={{
                                    textField: {
                                        variant: 'standard',
                                    },
                                }}
                                sx={{

                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none !important",
                                        maxWidth: "70%",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        maxWidth: "90%",
                                    },
                                    "& .MuiIconButton-root": {
                                        margin: "0px",
                                        padding: "0px",
                                        color: "#7C9FB2",
                                    },
                                    "& .MuiSvgIcon-root": {
                                        fontSize: { xs: "32px", md: "20px" },
                                    },

                                    "& .MuiOutlinedInput-root": {
                                        margin: "0px",
                                        paddingLeft: "0px",
                                        // maxWidth:'190px !important'
                                    },
                                    "& .MuiInput-root::before ": {
                                        borderBottom: 'none'
                                    }
                                }}
                            />

                            <IconButton
                                onClick={handleNextMonth}
                                className="d-none d-md-block"
                            >
                                <KeyboardArrowRight />
                            </IconButton>

                        </Box>
                    </LocalizationProvider>
                </Box>
            </Box>
            <Box className='d-flex mb-5 flex-wrap align-items-stretch justify-content-between flex-wrap'>
                <Box onClick={() => { navigate('/dashboard/myTasks', { state: { activeposition: 'completed' } }) }} width={{ xs: "49%", lg: '33%' }} minHeight={{ xs: "auto", lg: "auto" }} justifyContent={{ xs: "start", lg: 'space-between' }} className='d-flex bg-alternate flex-column mt-2 border' p={{ xs: '10px', lg: 3 }} borderRadius={{ xs: "15px", lg: '20px' }}>
                    <Box component='img' src={dashboard1} className='col-lg-2 col-2'></Box>
                    <Box flexDirection={{ xs: "column", lg: 'row' }} alignItems={{ xs: 'start', lg: 'center' }} mt={{ xs: 0, lg: 3 }} className='d-flex justify-content-between'>
                        <Typography className='text-main' whiteSpace='nowrap' fontSize={{ xs: "14px", lg: '24px' }}>Task Completed</Typography>
                        <Typography className='text-main fw-bolder' fontSize={{ xs: "32px", lg: '36px' }}>{Dashboarddata?.reports?.summary?.totalSubmitReportCount ?? 'N/A'}</Typography>
                    </Box>
                </Box>
                <Box width={{ xs: "49%", lg: '33%' }} minHeight={{ xs: "auto", lg: 'auto' }} justifyContent={{ xs: "start", lg: 'space-between' }} className='d-flex bg-second flex-column mt-2 border' p={{ xs: 1, lg: 3 }} borderRadius={{ xs: "15px", lg: '20px' }}>
                    <Box component='img' src={dashboard2} className='col-lg-2 col-2'></Box>
                    <Box flexDirection={{ xs: "column", lg: 'row' }} alignItems={{ xs: 'start', lg: 'center' }} className='d-flex justify-content-between'>
                        <Typography className='text-main' fontSize={{ xs: "14px", lg: '24px' }}>Amount So Far</Typography>
                        <Typography className='text-main fw-bolder' fontSize={{ xs: "32px", lg: '36px' }}>${Dashboarddata?.reports?.summary?.totalEarnedAmount ?? 'N/A'}</Typography>
                    </Box>
                </Box>
                <Box width={{ xs: "49%", lg: '33%' }} minHeight={{ xs: "auto", lg: 'auto' }} justifyContent={{ xs: "start", lg: 'space-between' }} className='d-flex bg-third flex-column mt-2 border' p={{ xs: 1, lg: 3 }} borderRadius={{ xs: "15px", lg: '20px' }}>
                    <Box component='img' src={dashboard3} className='col-lg-2  col-2'></Box>
                    <Box flexDirection={{ xs: "column", lg: 'row' }} alignItems={{ xs: 'start', lg: 'center' }} className='d-flex justify-content-between'>
                        <Typography className='text-main' fontSize={{ xs: "14px", lg: '24px' }}>Amount Spent</Typography>
                        <Typography className='text-main fw-bolder' fontSize={{ xs: "32px", lg: '36px' }}>${Dashboarddata?.reports?.summary?.totalSpentAmount ?? 'N/A'}</Typography>
                    </Box>
                </Box>
                <Box onClick={() => { navigate('/dashboard/myTasks', { state: { activeposition: 'approved' } }) }} width={{ xs: "49%", lg: '33%' }} minHeight={{ xs: "auto", lg: 'auto' }} justifyContent={{ xs: "start", lg: 'space-between' }} className='d-flex bg-second flex-column gap-2  mt-2 border' p={{ xs: 1, lg: 3 }} borderRadius={{ xs: "15px", lg: '20px' }}>
                    <Box component='img' src={dashboard4} className='col-lg-2 col-2'></Box>
                    <Box flexDirection={{ xs: "column", lg: 'row' }} alignItems={{ xs: 'start', lg: 'center' }} className='d-flex justify-content-between'>
                        <Typography className='text-main' fontSize={{ xs: "14px", lg: '24px' }}>Pending  Tasks</Typography>
                        <Typography className='text-main fw-bolder' fontSize={{ xs: "32px", lg: '36px' }}>{Dashboarddata?.reports?.summary?.totalPendingReportCount ?? 'N/A'}</Typography>
                    </Box>
                </Box>
                <Box onClick={() => { navigate('/dashboard/myTasks', { state: { activeposition: 'applied' } }) }} width={{ xs: "49%", lg: '33%' }} minHeight={{ xs: "auto", lg: 'auto' }} justifyContent={{ xs: "start", lg: 'space-between' }} className='d-flex bg-third  flex-column gap-2  mt-2 border' p={{ xs: 1, lg: 3 }} borderRadius={{ xs: "15px", lg: '20px' }}>
                    <Box component='img' src={dashboard5} className='col-lg-2 col-2'></Box>
                    <Box flexDirection={{ xs: "column", lg: 'row' }} alignItems={{ xs: 'start', lg: 'center' }} className='d-flex  justify-content-between'>
                        <Typography className='text-main' fontSize={{ xs: "14px", lg: '24px' }}>Applied  Tasks</Typography>
                        <Typography className='text-main fw-bolder' fontSize={{ xs: "32px", lg: '36px' }}>{Dashboarddata?.allocations?.totalAppliedAllocationCount ?? "N/A"}</Typography>
                    </Box>
                </Box>
                <Box onClick={() => { navigate('/dashboard/myTasks', { state: { activeposition: 'approved' } }) }} width={{ xs: "49%", lg: '33%' }} minHeight={{ xs: "auto", lg: 'auto' }} justifyContent={{ xs: "start", lg: 'space-between' }} className='d-flex bg-alternate flex-column gap-2 mt-2 border' p={{ xs: 1, lg: 3 }} borderRadius={{ xs: "15px", lg: '20px' }}>
                    <Box component='img' src={dashboard6} className='col-lg-2 col-2'></Box>
                    <Box flexDirection={{ xs: "column", lg: 'row' }} alignItems={{ xs: 'start', lg: 'center' }} className='d-flex justify-content-between'>
                        <Typography className='text-main' fontSize={{ xs: "14px", lg: '24px' }}>Approved  Tasks</Typography>
                        <Typography className='text-main fw-bolder' fontSize={{ xs: "32px", lg: '36px' }}>{Dashboarddata?.allocations?.totalApprovedAllocationsCount ?? 'N/A'}</Typography>
                    </Box>
                </Box>
            </Box>
            <Box>
                <Box className='d-flex  align-items-center bg-alternate border-10 justify-content-between px-2 py-1'>
                    <Box className='d-flex align-items-center' gap={2}>
                        <Box component='img' src={dashboard7} className='col-2'></Box>
                        <Typography fontSize={{ xs: "12px", lg: '24px' }}>Shopper's Rating</Typography>
                    </Box>
                    <Typography fontWeight='bold' fontSize={'24px'}>{Dashboarddata?.shopperOverAllRating}/100</Typography>
                </Box>
            </Box>


            <Dialog sx={{ maxWidth: "600px", mx: 'auto' }} open={false}>
                <DialogContent className="py-0">
                    <Box className='mb-2 mt-4'>
                        <Box className='d-flex align-items-center justify-content-between'>
                            <Typography variant="h6" className="fw-bold">Currently Under Maintenance</Typography>
                            <IconButton className="m-0 p-0" onClick={() => {
                                window.close()
                            }}>
                                <Close />
                            </IconButton>
                        </Box>
                        <Typography variant="body1" className="mt-3">We’re currently performing scheduled maintenance on the Shopper Portal.</Typography>
                        <Typography variant="body1" className="mt-3">The Shopper Portal will be unavailable on 28 and 29 September.</Typography>
                        <Typography variant="body1" className="mt-3">We apologise for any inconvenience and appreciate your patience while we complete these improvements.</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    {/* <Box className='d-flex align-items-center gap-20'> */}
                    <Button onClick={() => {
                        window.close();
                    }} className="button-primary mb-2  px-3 py-2">OK</Button>
                    {/* </Box> */}
                </DialogActions>

            </Dialog>

            {loading && <Loading />}
        </Box>


    )
}

export default Dashboard
